import { ReadonlyInput } from 'components/common/ReadonlyInput';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import usePushManagementLive from 'lib/hooks/usePushManagementLive';
import {
  getLabelByValueFromOptions,
  PushActionHappyTabsOptions,
  PushActionTabularyTabsOptions,
  PushCardOptions,
  PushTabOptions,
} from '../constants';

export const TabLive = () => {
  const { pushConfig, isLoading } = usePushManagementLive();

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <div className="p-4">
      <div className="flex">
        <div className="flex-grow">
          {pushConfig.map(
            (
              {
                type,
                deliveryTime,
                days,
                specificDay: isSpecificDay,
                dayTitle,
                dayMessage,
                tabType,
                cardType,
                actionHappyTabsType,
                actionTabularyTabsType,
                unflipAllTabs,
                active,
              },
              index,
            ) => {
              return (
                <div className="pb-4 mb-4 border-b border-gray-200" key={index}>
                  <p className="text-lg mb-4">{type}</p>
                  <div className="grid grid-cols-11 gap-2">
                    <div className="col-span-2">
                      <ReadonlyInput
                        label="Push title"
                        value={dayTitle}
                        isDisabled={isSpecificDay}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    </div>
                    <div className="col-span-2">
                      <ReadonlyInput
                        label="Push message"
                        value={dayMessage}
                        isDisabled={isSpecificDay}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    </div>
                    <div className="">
                      <ReadonlyInput
                        label="Push time"
                        value={deliveryTime}
                        isDisabled={isSpecificDay}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    </div>
                    <div className="">
                      <ReadonlyInput
                        value={isSpecificDay ? 'Yes' : 'No'}
                        label="Day Specific"
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    </div>
                    <div className="">
                      <ReadonlyInput
                        value={active ? 'Yes' : 'No'}
                        label="Active"
                        isDisabled={isSpecificDay}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    </div>
                    <div className="">
                      <ReadonlyInput
                        label="Tab type"
                        value={getLabelByValueFromOptions(
                          tabType,
                          PushTabOptions,
                        )}
                        isDisabled={isSpecificDay}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    </div>
                    <div className="">
                      {tabType === 'happy_tabs' && (
                        <ReadonlyInput
                          label="Action"
                          value={getLabelByValueFromOptions(
                            actionHappyTabsType,
                            PushActionHappyTabsOptions,
                          )}
                          isDisabled={isSpecificDay}
                          labelStyle="block text-sm text-gray-400 mb-2"
                          inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                        />
                      )}
                      {tabType === 'tabulary' && (
                        <ReadonlyInput
                          label="Action"
                          value={getLabelByValueFromOptions(
                            actionTabularyTabsType,
                            PushActionTabularyTabsOptions,
                          )}
                          isDisabled={isSpecificDay}
                          labelStyle="block text-sm text-gray-400 mb-2"
                          inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                        />
                      )}
                    </div>
                    <div className="">
                      {tabType === 'happy_tabs' && (
                        <ReadonlyInput
                          label="Card"
                          value={getLabelByValueFromOptions(
                            cardType,
                            PushCardOptions,
                          )}
                          isDisabled={isSpecificDay}
                          labelStyle="block text-sm text-gray-400 mb-2"
                          inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                        />
                      )}
                    </div>
                    <div className="">
                      {tabType === 'happy_tabs' &&
                        actionHappyTabsType &&
                        actionHappyTabsType !== 'compose' && (
                          <ReadonlyInput
                            label="Unflip"
                            value={unflipAllTabs ? 'Yes' : 'No'}
                            isDisabled={isSpecificDay}
                            labelStyle="block text-sm text-gray-400 mb-2"
                            inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                            controlStyle="bg-blue-30 mb-4 w-full relative"
                          />
                        )}
                    </div>
                  </div>
                  <div>
                    {isSpecificDay &&
                      days?.map((day) => (
                        <div className="grid grid-cols-11 gap-2" key={day.id}>
                          <div className="col-span-2">
                            <ReadonlyInput
                              label={`${day.day?.toUpperCase()} Push title`}
                              value={day.specificDayTitle}
                              labelStyle="block text-sm text-gray-400 mb-2"
                              inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                              controlStyle="bg-blue-30 mb-4 w-full relative"
                            />
                          </div>
                          <div className="col-span-2">
                            <ReadonlyInput
                              label={`${day.day?.toUpperCase()} Push message`}
                              value={day.specificDayMessage}
                              labelStyle="block text-sm text-gray-400 mb-2"
                              inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                              controlStyle="bg-blue-30 mb-4 w-full relative"
                            />
                          </div>
                          <div className="">
                            <ReadonlyInput
                              label="Push time"
                              value={day.deliveryTime}
                              labelStyle="block text-sm text-gray-400 mb-2"
                              inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                              controlStyle="bg-blue-30 mb-4 w-full relative"
                            />
                          </div>
                          <div className="" />
                          <div className="">
                            <ReadonlyInput
                              value={day.active ? 'Yes' : 'No'}
                              label="Active"
                              labelStyle="block text-sm text-gray-400 mb-2"
                              inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                              controlStyle="bg-blue-30 mb-4 w-full relative"
                            />
                          </div>
                          <div className="">
                            <ReadonlyInput
                              label="Tab type"
                              value={getLabelByValueFromOptions(
                                day.tabType,
                                PushTabOptions,
                              )}
                              labelStyle="block text-sm text-gray-400 mb-2"
                              inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                              controlStyle="bg-blue-30 mb-4 w-full relative"
                            />
                          </div>
                          <div className="">
                            {day.tabType === 'happy_tabs' && (
                              <ReadonlyInput
                                label="Action"
                                value={getLabelByValueFromOptions(
                                  day.actionHappyTabsType,
                                  PushActionHappyTabsOptions,
                                )}
                                labelStyle="block text-sm text-gray-400 mb-2"
                                inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                                controlStyle="bg-blue-30 mb-4 w-full relative"
                              />
                            )}
                            {day.tabType === 'tabulary' && (
                              <ReadonlyInput
                                label="Action"
                                value={getLabelByValueFromOptions(
                                  day.actionTabularyTabsType,
                                  PushActionTabularyTabsOptions,
                                )}
                                labelStyle="block text-sm text-gray-400 mb-2"
                                inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                                controlStyle="bg-blue-30 mb-4 w-full relative"
                              />
                            )}
                          </div>
                          <div className="">
                            {day.tabType === 'happy_tabs' && (
                              <ReadonlyInput
                                label="Card"
                                value={getLabelByValueFromOptions(
                                  day.cardType,
                                  PushCardOptions,
                                )}
                                labelStyle="block text-sm text-gray-400 mb-2"
                                inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                                controlStyle="bg-blue-30 mb-4 w-full relative"
                              />
                            )}
                          </div>
                          <div className="">
                            {day.tabType === 'happy_tabs' &&
                              day.actionHappyTabsType &&
                              day.actionHappyTabsType !== 'compose' && (
                                <ReadonlyInput
                                  label="Unflip"
                                  value={day.unflipAllTabs ? 'Yes' : 'No'}
                                  labelStyle="block text-sm text-gray-400 mb-2"
                                  inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                                  controlStyle="bg-blue-30 mb-4 w-full relative"
                                />
                              )}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              );
            },
          )}
        </div>
        <div className="w-32"></div>
      </div>
    </div>
  );
};
